import React from "react";
import { MapPin, Clock, Phone, ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Showroom() {
  const ref = useReveal();
  return (
    <section id="showroom" className="bg-navy py-16">
      <div ref={ref} className="reveal mx-auto grid max-w-7xl items-center gap-10 px-4 lg:grid-cols-2 lg:px-8">
        <div className="overflow-hidden rounded-3xl border-4 border-white/10 shadow-2xl">
          <iframe
            title="Cyberfit Showroom Map"
            src="https://www.google.com/maps?q=Cyberfit+Gym+Equipment+Seven+Hills+NSW&output=embed"
            className="h-[360px] w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="text-white">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-brand">Come Say Hi</p>
          <h2 className="font-heading text-3xl font-extrabold md:text-4xl">Visit our Sydney Showroom</h2>
          <p className="mt-4 text-white/70">
            We welcome walk-ins and appointments at our Sydney showroom in Seven Hills, NSW. It&rsquo;s
            an excellent opportunity to test equipment, ask questions and get personalised
            recommendations. Outside NSW? We also offer video walk-throughs.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <p className="flex items-center gap-3"><MapPin size={18} className="text-brand" /> Unit 27, 14 Stanton Rd, Seven Hills NSW 2147</p>
            <p className="flex items-center gap-3"><Clock size={18} className="text-brand" /> Mon&ndash;Fri 10am&ndash;4pm &middot; Sat 10am&ndash;2pm</p>
            <p className="flex items-center gap-3"><Phone size={18} className="text-brand" /> 02 9620 6635</p>
          </div>
          <a
            href="https://maps.app.goo.gl/ZTo8XWBKLxpxp1QW8"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-3 font-heading font-bold text-navy transition-colors hover:bg-brand hover:text-white"
          >
            Get Directions <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
